import { utils, write } from "xlsx";

export function subProgrammes(response) {
  const trainingData = response.map((data) => {
    return [data.code ?? "", data.title ?? "", data.count ?? ""];
  });

  const headers = ["Code", "Title", "Project Count"];

  // Combine the headers with the training data
  const data = [headers, ...trainingData];

  // Create a new workbook
  const wb = utils.book_new();
  // Add a worksheet with the data
  const ws = utils.aoa_to_sheet(data);
  // Apply filter to the worksheet
  ws["!autofilter"] = {
    ref: "A1:C1",
  };
  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  // Generate a blob from the workbook
  const wbout = write(wb, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([wbout], {
    type: "application/octet-stream",
  });
  // Create a temporary anchor element to trigger the download
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  // Set the download URL and click the anchor to trigger the download
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = "Sub_Programmes.xlsx";
  a.click();
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

export function projects(response) {
  const trainingData = response.map((data) => {
    return [data.code ?? "", data.title ?? "", data.count ?? ""];
  });

  const headers = ["Code", "Title", "Trainings Count"];

  // Combine the headers with the training data
  const data = [headers, ...trainingData];

  // Create a new workbook
  const wb = utils.book_new();
  // Add a worksheet with the data
  const ws = utils.aoa_to_sheet(data);
  // Apply filter to the worksheet
  ws["!autofilter"] = {
    ref: "A1:C1",
  };
  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  // Generate a blob from the workbook
  const wbout = write(wb, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([wbout], {
    type: "application/octet-stream",
  });
  // Create a temporary anchor element to trigger the download
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  // Set the download URL and click the anchor to trigger the download
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = "Projects.xlsx";
  a.click();
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

export function trainings(response) {
  const trainingData = response.map((data) => {
    return [
      data.title ?? "",
      data.po ?? "",
      data.advisor ?? "",
      data.doner ?? "",
      data.startDate ?? "",
      data.endDate ?? "",
      data.venue ?? "",
      data.city ?? "",
      data.days ?? "",
      data.postAssesment ?? "",
      data.preAssesment ?? "",
    ];
  });

  const headers = [
    "Title",
    "Program Officer",
    "Advisor",
    "Donor",
    "Start Date",
    "End Date",
    "Venue",
    "City",
    "Days",
    "Post Assesment",
    "Pre Assesment",
  ];

  // Combine the headers with the training data
  const data = [headers, ...trainingData];

  // Create a new workbook
  const wb = utils.book_new();
  // Add a worksheet with the data
  const ws = utils.aoa_to_sheet(data);
  // Apply filter to the worksheet
  ws["!autofilter"] = {
    ref: "A1:C1",
  };
  // Append the worksheet to the workbook
  utils.book_append_sheet(wb, ws, "Sheet1");
  // Generate a blob from the workbook
  const wbout = write(wb, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([wbout], {
    type: "application/octet-stream",
  });
  // Create a temporary anchor element to trigger the download
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  // Set the download URL and click the anchor to trigger the download
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = "Events.xlsx";
  a.click();
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
